import { render, staticRenderFns } from "./CVNewValue.vue?vue&type=template&id=4f254ca8&"
import script from "./CVNewValue.vue?vue&type=script&lang=js&"
export * from "./CVNewValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports